import React, {useLayoutEffect} from "react";
import Headline from "../../Headline/Headline";
import Section from "../../UI/Others/Section";
import { useIntl } from "react-intl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons"

const Learn = () => {

    const intl = useIntl();

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    
    const title = intl.messages.learnTitle;
    const subtitle = intl.messages.learnMessage;

    function VideoCard(props) {
        return (
            <div className="d-flex col-xs-12 col-md-6 col-xl-4">
                <div className="card">
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe loading="lazy"
                            className="embed-responsive-item"
                            src={props.link}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            title={props.title}
                            allowFullScreen
                        />
                    </div>                   
                    
                    <div className="card-body">
                    <h5><span className="badge badge-success mt-3">{props.type}</span></h5>
                        <h6 className="card-title">{props.title}</h6>
                        <p className="card-text">{props.description}</p>
                    </div>
                    
                    <div className="card-footer"><hr/>
                        <FontAwesomeIcon icon={faClock} className="text-green" /><small>&nbsp;&nbsp;{props.footer}</small>
                    </div>
                </div> 
            </div>
        );
    }

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
            {/* Message d'accueil */}
                <div className="col">
                    <div className="card">
                        <div className="card-text">
                            {intl.messages.learnDescription}
                        </div>
                    </div>
                </div>
            </div>

            <Section 
                title={intl.messages.learnSection1} 
                className="bg-green"
            />

            <div className="row">
                <VideoCard id="Video1"
                    title={"Connex Web Series - "+intl.formatMessage({ id: "learnSeason" }, { num:"1"})+ ", " + intl.formatMessage({ id: "learnEpisode" }, { num:"10"})}
                    type={intl.messages.learnVideo}
                    description={intl.messages.learnVideoMsg1}
                    footer={intl.formatDate(new Date("February 25, 2019"), { year: "numeric", month: "long", day: "numeric" })}
                    link="https://www.youtube.com/embed/yqugPibjOh0?list=PL-mHF9yP7tLB9ZaMqaB8S-uQiKRIR-7fy"
                >
                </VideoCard>
            
                <VideoCard id="Video2"
                    title={"Connex Web Series - "+intl.formatMessage({ id: "learnSeason" }, { num:"1"})+ ", " + intl.formatMessage({ id: "learnEpisode" }, { num:"9"})}
                    type={intl.messages.learnVideo}
                    description={intl.messages.learnVideoMsg2}
                    footer={intl.formatDate(new Date("February 11, 2019"), { year: "numeric", month: "long", day: "numeric" })}
                    link="https://www.youtube.com/embed/m8L9hxK_iWY"
                >
                </VideoCard>
            </div>

            <Section 
                title={intl.messages.learnSection2} 
                className="bg-green"
            />

            <div className="row">
                <VideoCard id="Video3"
                    title={"Talk to Experts Series - " + intl.formatMessage({ id: "learnEpisode" }, { num:"4"})}
                    type={intl.messages.learnWebinar}
                    description={intl.messages.learnVideoMsg3}
                    footer={intl.formatDate(new Date("January 29 2020"), { year: "numeric", month: "long", day: "numeric" })}
                    link="https://www.youtube.com/embed/zL9X-GvUCyY"
                >
                </VideoCard>
                
                <VideoCard id="Video4"
                    title={"Talk to Experts Series - " + intl.formatMessage({ id: "learnEpisode" }, { num:"3"})}
                    type={intl.messages.learnWebinar}
                    description={intl.messages.learnVideoMsg4}
                    footer={intl.formatDate(new Date("May 29 2019"), { year: "numeric", month: "long", day: "numeric" })}
                    link="https://www.youtube.com/embed/5JE8bs7_8cg?list=PLrzAZN530GJ8YqxafRIOtlbBNwkdSX-Cz"
                >    
                </VideoCard>
                
                <VideoCard id="Video5"
                    title={"Talk to Experts Series - " + intl.formatMessage({ id: "learnEpisode" }, { num:"2"})}
                    type={intl.messages.learnWebinar}
                    description={intl.messages.learnVideoMsg5}
                    footer={intl.formatDate(new Date("February 27 2019"), { year: "numeric", month: "long", day: "numeric" })}
                    link="https://www.youtube.com/embed/92nLc2E28S8?list=PLrzAZN530GJ8YqxafRIOtlbBNwkdSX-Cz"
                >
                </VideoCard>
                
                <VideoCard id="Video6"
                    title={"Talk to Experts Series - " + intl.formatMessage({ id: "learnEpisode" }, { num:"1"})}
                    type={intl.messages.learnWebinar}
                    description={intl.messages.learnVideoMsg6}
                    footer={intl.formatDate(new Date("February 12 2018"), { year: "numeric", month: "long", day: "numeric" })}
                    link="https://www.youtube.com/embed/ei2g_rql0Uw?list=PLrzAZN530GJ8YqxafRIOtlbBNwkdSX-Cz"
                >
                </VideoCard>
            </div>

        </div>
    );
}

export default Learn;